module.exports = __webpack_public_path__ + "img/流体力学1_5_4.64af5a8a.jpg";